import React from 'react'
import { Grid } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { dataCatalog } from '../../../../api/coreData'
import EmptySection from '../../../atoms/EmptySection'
import Loading from '../../../molecules/Loading'
import DatasourceLayout from './shared/DatasourceLayout'

const SEARCH_VALUE = {
  filters: {
    type: 'api'
  },
  includes: {
    namespace: true
  }
}

function CatalogPipelines () {
  const { data, isLoading } = dataCatalog.useSearchCatalogDataSources(SEARCH_VALUE)

  if (isLoading) {
    return (
      <FadeIn key='loading'>
        <Loading />
      </FadeIn>
    )
  }

  if (!(data?.total || 0)) {
    return (
      <FadeIn key='no_data'>
        <EmptySection title='No Pipelines' description='' />
      </FadeIn>
    )
  }

  return (
    <FadeIn key='pipelines'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DatasourceLayout items={data?.data || []} />
        </Grid>
      </Grid>
    </FadeIn>
  )
}

export default CatalogPipelines
